import React from 'react';
import TransactionContainer from './TransactionContainer';

const TransactionView = () => {
  return <TransactionContainer />;
};

export default TransactionView;
